import React from 'react';
import { isNil } from 'lodash';
import {
  FinalFee,
  FinalFeeType,
  FinanceResponseData,
} from '@upstart/harmony/lib/legos/financingTypes';
import { Select } from '../../../../components/PencilEditor';
import { FeeItem } from './FeeItem';

const EmmisionFees = [
  {
    name: 'State Emissions Certification Fee',
    type: FinalFeeType.EMISSIONS_CERTIFICATION,
  },
  {
    name: 'State Emissions Exemption Fee',
    type: FinalFeeType.EMISSIONS_EXEMPTION,
  },
];
const NON_FEE = 'None';

export function EmissionsFeeItem(props: {
  fee: FinalFee | undefined;
  responseData?: FinanceResponseData;
  onChange: (data: Partial<FinanceResponseData>) => void;
}) {
  const { responseData, fee, onChange } = props;

  return (
    <FeeItem
      isValueDisabled={isNil(fee)}
      description={
        <Select
          value={fee?.type}
          onChange={(newType: FinalFeeType | typeof NON_FEE) => {
            const currentList = responseData?.finalizedFeeList ?? [];
            let finalizedFeeList = currentList.filter(
              finalizedFee =>
                !EmmisionFees.map(f => f.type).includes(finalizedFee.type),
            );
            if (newType && newType !== NON_FEE) {
              const newFee = { type: newType, value: fee?.value ?? 0 };
              finalizedFeeList = finalizedFeeList.concat(newFee);
            }
            onChange({ finalizedFeeList });
          }}
        >
          <Select.Option key={NON_FEE} name={NON_FEE} value={null} />
          {EmmisionFees.map(f => (
            <Select.Option key={f.name} name={f.name} value={f.type} />
          ))}
        </Select>
      }
      {...props}
      fee={
        fee || {
          value: 0,
          type: FinalFeeType.EMISSIONS_CERTIFICATION,
        }
      }
    />
  );
}

export default EmissionsFeeItem;
